<template>
  <div class="vx-col w-full mb-base" ref="popupContainer">
    <FilterCard :refreshKey="1" :filters="filtersTemplates" :showRowNum="false" :showListLength="displayedProviders.length" @filter="handleFilterEmits($event)" :actions="actionsTemplates" @action="handleActionEmits($event)" :onChangeEmit="true" @clearAll="resetAllFilter()"/>

    <vx-card style="max-height:79vh; overflow: auto;">
      <div ref="providerTable">
        <ProvidersTable :purchases="purchases" :providers="displayedProviders" :services="services" @delete-line="removeLine($event)" @modify-provider="displayProviderPopup($event)"/>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import FilterCard from "@/views/filters/FilterCard";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import ProvidersTable from "@/components/tables/ProvidersTable";
import ProviderInfoPopup from "@/components/popups/ProviderInfoPopup";
import XLSX from "xlsx";
import {VueTags} from "vue-tags-component";


export default {
	name: "ProvidersDashboard",
	mixins: [utilsMixin, dbFieldConvertor],
	components: {
		ProvidersTable,
		VueTags,
		FilterCard
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			showProviderPopup: false,
			selectedProvider: null,
			nameFilter: "",
			societyFilter: "",
			activeFilter: false,
			expertiseFilter: "",
			statusFilter: "",
			nameFilterOn: false,
			societyFilterOn: false,
			activeFilterOn: false,
			expertiseFilterOn: false,
			statusFilterrOn: false,
			displayedProviders: [],
			apiUrl: store.state.backendApiUrl,
			actionsTemplates: [{
				order: 1,
				emitSlugName: "new_provider",
				buttonName: "Nouveau prestataire",
				buttonIcon: "icon-plus-circle",
				buttonColor: "primary",
			}, {
				order: 2,
				emitSlugName: "action_extract_providers",
				buttonName: "Exporter",
				buttonIcon: "icon-download-cloud",
				buttonColor: "dark",
			}, ],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Société",
					value: "",
					type: "Input",
				}, {
					order: 2,
					emitSlugName: "filter_expertise",
					filterPlaceHolder: "Expertise",
					value: "",
					type: "Input"
				}, {
					order: 3,
					emitSlugName: "filter_tag",
					filterPlaceHolder: "Tags",
					value: "",
					type: "Tag",
					params: {
						domainFilter: [],
						activityDomainOptions: []
					}
				},
				{
					order: 4,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						// multiple: true,
						dropdownValues: this.getProvidersStatus()
					}
				}],

			//Tags
			domainFilter: [],
			activityDomainOptions: [],
			tagStyle: "z-index: 1600 !important;"
		};
	},
	/*
	 * beforeRouteEnter(to, from, next) {
	 *   // Save the previous route name in the session storage
	 *   sessionStorage.setItem("prevRoute", from.name);
	 *   next();
	 * },
	 */

	 async created() {
		////console.log("created BEGIN")

		this.getAllServices();
		this.getAllProviders();
		this.getAllActivityDomain();
		this.getAllProvidersTags();
		////console.log("created END")
	},
	mounted() {
		////console.log("created BEGIN")
		this.displayedProviders = this.displayProviders(this.providers);
		/*
		 * //console.log("created END")
		 *  if(sessionStorage.getItem("prevRoute") != "return_page"){
		 *    this.$router.push({ name: 'return_page' })
		 *  }
		 */
	},
	watch: {
		purchases: function(data){
			/*
			 * //console.log("purchases WATCH")
			 *  this.displayedPurchases = this.displayPurchases(this.purchases)
			 *  this.loadFilters()
			 *  //console.log("data: ", data)
			 */

			this.displayedPurchasesFull = data;
			// //console.log("this.displayedPurchasesFull: ", this.displayedPurchasesFull)

		},
		providers: function(data){
			////console.log("providers WATCH")
			this.displayedProviders = this.displayProviders(data);
		},
		societyFilter: function() {
			if(this.societyFilter == "") {
				this.societyFilterOn = false;
			}
			else{
				this.societyFilterOn = true;
			}
			////console.log("societyFilter")
			this.displayedProviders = this.filterProviders(this.providers); //A CHANGER
		},
		
		statusFilter: function() {
			if(this.statusFilter == "") {
				this.statusFilterOn = false;
			}
			else{
				this.statusFilterOn = true;
			}
			////console.log("statusFilter")
			this.displayedProviders = this.filterProviders(this.providers); //A CHANGER
		},
		expertiseFilter: function() {
			if(this.expertiseFilter == "") {
				this.expertiseFilterOn = false;
			}
			else{
				this.expertiseFilterOn = true;
			}
			////console.log("expertiseFilter")
			this.displayedProviders = this.filterProviders(this.providers); //A CHANGER
		},
		domainFilter: function() {
			this.displayedProviders = this.filterProviders(this.providers);
		},
	},
	computed: {
		providers: () => {
			return store.state.providers;
		},

		providers_tags: () => {
			return store.state.providers_tags;
		},

		services: () => {
			return store.state.services;
		},
		purchases: () => {
			return store.state.purchases;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
	},
	methods: {
		getAllCollaborators(){
			this.$store.dispatch("getAllCollaborators");
			this.filtersTemplates[0].params.dropdownValues = this.allCollaborators.filter(collaborator => [3, 6, 7, 9].includes(collaborator.type)).sort((a, b) => {
				return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
			}).map(row => {
				return {id: row.id, name: row.firstname + " " + row.lastname};
			});
		},
		getAllPurchases() {
			////console.log("getAllPurchases BEGIN")
			this.$store.dispatch("getAllPurchasesWithRecurring");
			////console.log("getAllPurchases END")
		},
		resetAllFilter(){
			this.nameFilter = "",
			this.societyFilter = "",
			this.activeFilter = false,
			this.expertiseFilter = "",
			this.activityDomainOptions = [];
			this.domainFilter= [];
			this.nameFilterOn = false,
			this.societyFilterOn = false,
			this.activeFilterOn = false,
			this.expertiseFilterOn = false,

			this.displayProviders(this.providers);
		},

		onTagAdded(tag){
			if(this.domainFilter.indexOf(tag) < 0) this.domainFilter.push(tag);
		},

		onTagRemoved(tag){
			this.domainFilter.splice(this.domainFilter.indexOf(tag), 1);
		},

		getAllActivityDomain(){
			this.$http.get(this.apiUrl + "tags/all").then(res => {
				let tmp = res.data;
				for(let tag of tmp){
					tag["name"] = tag.tag_name;
					tag["slug"] = tag.tag_name;
					delete tag.tag_name;
				}
				this.activityDomainOptions = tmp;
				this.filtersTemplates[2].params.activityDomainOptions = tmp;
			})
				.catch(err => console.log(err));
		},

		/**
		 * Fetch all the providers
		 */
		getAllProviders() {
			////console.log("getAllProviders BEGIN")
			store.dispatch("getAllProviders");
			////console.log("getAllProviders END")
		},

		getAllProvidersTags() {
			////console.log("getAllProviders BEGIN")
			store.dispatch("getAllProvidersTags");
			////console.log("getAllProviders END")
		},

		/**
		 * Fetch all the services
		 */
		getAllServices() {
			////console.log("getAllProviders BEGIN")
			store.dispatch("getAllServices");
			////console.log("getAllServices END")
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			service_name = service.name;
			// if(this.providerCount == this.providerCountTarget) this.forceRerenderExpertises()
			return service_name;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(row => row.emitSlugName == receivedEmit[0]);
			if(templateRowIndex >= 0) this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch(receivedEmit[0]){
			case"filter_client":
				this.societyFilter = receivedEmit[1].value;
				break;
			case"filter_tag":
				this.domainFilter = receivedEmit[1].value;
				break;
			case"filter_status":
				this.statusFilter = receivedEmit[1].value;
				break;
			case"filter_expertise":
				this.expertiseFilter = receivedEmit[1].value;
				break;
			default:
				break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			switch(receivedEmit[0]){
			case"action_extract_provider":
				this.exportData(this.providers);
				break;
			case"new_provider":
				// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
				this.$router.push({name: "new_entity"});
				break;
			default:
				break;
			}
		},

		refreshTable(){
			this.displayedProviders = null;
			this.displayedProviders = this.displayProviders(this.providers);
			//console.log("refreshTable");
		},

		removeLine(provider){
			let providerToDelete = this.providers.find(element => element.id == provider.id);
			//console.log(providerToDelete);
			this.providers = this.providers.filter(function(element){
				return element.id != provider.id;
			});
			this.displayedProviders = this.providers;
			//console.log("removeLine");
		},

		modifyProvider(providerId){
			this.$router.push({name: "update_entity", params: {providerId: providerId, updateEntityForm: "providers"}});
		},

		createTable(){
			/*
			 * //console.log("createTable BEGIN")
			 * Instancie la class ProvidersTable pour mount sur la balise div refreshTable
			 */
			let ComponentClass = Vue.extend(ProvidersTable);
			// <ProvidersTable :providers="providers" :services="services" @refreshTable="refreshTable"/>
			let providersTable = new ComponentClass({
				propsData: {
					providers: this.providers,
					services: this.services,
				}
			});
			providersTable.$mount();
			providersTable.$on("refreshTable", () => {
				this.refreshTable();
			});
			providersTable.$on("modifyProvider", (providerId) => {
				this.modifyProvider(providerId);
			});
			this.$refs.providerTable.appendChild(providersTable.$el);
			////console.log("createTable END")
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.commercialFilterOn || this.societyFilterOn || this.activeFilterOn || this.expertiseFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered providers A CHANGER
		 * @param {String} societyFilter - String to match in society name
		 * @return {List} - Societies' list filtered
		 */
		filterProviders(providers){
			console.log("filterProviders BEGIN")
			let providersList = JSON.parse(JSON.stringify(providers));

			if(this.societyFilter) providersList = providersList.filter(provider => provider.society.toLowerCase().includes(this.societyFilter.toLowerCase()));

			if(this.expertiseFilter) providersList = providersList.filter(provider => provider.service_name_list.filter(ex => ex.toLowerCase().indexOf(this.expertiseFilter.toLowerCase()) >= 0).length > 0);
			if(this.statusFilter) providersList = providersList.filter(provider => provider.status == this.statusFilter);

			if(this.domainFilter.length > 0) {
				let tagsIdList = [];
				for(let tag of this.domainFilter){
					tagsIdList.push(tag.id);
				}
				providersList = providersList.filter(provider => this.providers_tags.filter(pt => pt.provider_id == provider.id && tagsIdList.includes(pt.tag_id)).length > 0);
			}
			return providersList;
		},
		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displayProviders(providers){
			////console.log("displayProviders BEGIN")
			let providersList = [];
			if(!this.isFilterSet()){
				providersList = providers;
			}

			// getServiceIdToName
			if(providersList.length > 0){
				////console.log(providersList)
				for(let provider of providersList){
					/*
					 * //console.log("provider")
					 * //console.log(provider)
					 * //console.log("provider.service_id_list")
					 * //console.log(provider.service_id_list)
					 */
					let service_name_list = [];
					/*
					 * //console.log("provider.service_name_list")
					 * //console.log(provider.service_name_list)
					 */
					if(provider.service_name_list != undefined && provider.service_name_list.length > 0){
						////console.log("provider.service_name_list DEFINED")
						service_name_list = provider.service_name_list;
					}
					else{
						////console.log("provider.service_name_list UNDEFINED")
						if(provider.service_id_list != undefined && provider.service_id_list.length > 0){
							let splitService_id_list = provider.service_id_list.split(",");
							for(let service of splitService_id_list){
								service_name_list.push(this.getServiceIdToName(service));
							}
						}
					}
					provider.service_name_list = service_name_list;
				}
			}

			/*
			 * return result
			 * //console.log("displayProviders END")
			 */
			return providersList;
		},

		displayProviderPopup(provider) {
			//Initialisation des données pour le popup
			this.selectedProvider = null; // Always reset data before assigning it
			this.selectedProvider = provider;
			this.showProviderPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ProviderInfoPopup);
			let providerPopup = new ComponentClass({
				propsData: {
					provider: this.selectedProvider,
					popupActive: this.showProviderPopup,
					router: this.$router,
					apiUrl: this.apiUrl
				}
			});
			providerPopup.$mount();
			this.$refs.popupContainer.appendChild(providerPopup.$el);
		},

		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				let list_num = data[i]["service_id_list"].split(",");
				let list = [];
				for(let x = 0; x < list_num.length; x++){
					let service_id = list_num[x];
					for(let y = 0; y < this.services.length; y++){
						if(this.services[y]["id"] == service_id){
							list.push(this.services[y]["name"]);
						}
					}
				}
				data[i]["expertise"] = list.join(",");

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}

				this.$delete(data[i], "service_id_list");
				this.$delete(data[i], "status");
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Prestataires";
			let header = {
				header: [
					"id",
					"society",
					"website",
					"rate",
					"commentary",
					"expertise",
				],
				skipHeader: true,
				origin: -1
			};
			let header_names = [{
				id: "Identifiant",
				society: "Prestataire",
				website: "Site web",
				rate: "Note",
				commentary: "Commentaire",
				expertise: "Expertises",
			}];

			//this.arrayObjectToString(data, "service_id_list", "reference");

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);
			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Providers_export.xls");


		},
	}
};
</script>

<style>
.center {
  justify-content: center;
}
.tag{
  height: auto !important;
  background-color: rgb(180, 180, 180) !important;
}
.tags{
  height: 32px !important;
}
.tag-filter > .tags__shadow > .tags__active{
  border-radius: 5px 5px 5px 5px !important;
}
.tags__active{
  padding: 2px 0 0 2px !important;
  border-radius: 0 5px 5px 0 !important;
  min-height: 32px !important;
}
.tags__list{
  display: grid !important;
  max-height: 300px !important;
  overflow: auto !important;
}
.tags__list-item{
  min-height: auto !important;
  margin-bottom: 1px;
  padding: 0 5px 0 5px !important;
}
.tags__list-item-tag{
  height: auto !important;
  align-self: center;
  background-color: rgb(180, 180, 180) !important;
}
.tags__search{
  border: none;
}
</style>
